import { withDefaults } from '@warp-drive/legacy/model/migration-support';
import type { WithLegacy } from '@warp-drive/legacy/model/migration-support';
import type { Type } from '@warp-drive/core/types/symbols';

export type AuditLog = WithLegacy<{
  actorId: string | null;
  actorRole: string | null;
  action: string | null;
  targetType: string | null;
  targetId: string | null;
  metadata: Record<string, unknown> | null;
  ipAddress: string | null;
  createdAt: string | null;
  [Type]: 'audit-logs';
}>;

export const AuditLogSchema = withDefaults({
  type: 'audit-logs',
  fields: [
    { name: 'actorId', kind: 'attribute', type: 'string' },
    { name: 'actorRole', kind: 'attribute', type: 'string' },
    { name: 'action', kind: 'attribute', type: 'string' },
    { name: 'targetType', kind: 'attribute', type: 'string' },
    { name: 'targetId', kind: 'attribute', type: 'string' },
    { name: 'metadata', kind: 'attribute', type: 'object' },
    { name: 'ipAddress', kind: 'attribute', type: 'string' },
    { name: 'createdAt', kind: 'attribute', type: 'string' },
  ],
});
